import axios from 'axios'
const API_URL = process.env.REACT_APP_THEME_API_URL
const ADD_LEAD = `${API_URL}/add-lead`
const API = axios.create();
API.interceptors.request.use(
    config => {
        if (process.env.REACT_APP_CLIENT) {
            config.headers['X-App-Client'] = process.env.REACT_APP_CLIENT
        }
        if (process.env.REACT_APP_CLIENT_KEY) {
            config.headers['X-App-Key'] = process.env.REACT_APP_CLIENT_KEY
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export const addLead = (query) => {
    return API.post(ADD_LEAD, query).then((d) => d.data)
};